import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=0be795a9&"
import script from "./DashboardItem.vue?vue&type=script&lang=js&"
export * from "./DashboardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be795a9')) {
      api.createRecord('0be795a9', component.options)
    } else {
      api.reload('0be795a9', component.options)
    }
    module.hot.accept("./DashboardItem.vue?vue&type=template&id=0be795a9&", function () {
      api.rerender('0be795a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/nav-menu-items/DashboardItem.vue"
export default component.exports